// extracted by mini-css-extract-plugin
module.exports = {"colorSheetBody":"ColorSheetBody_colorSheetBody__quxN6","colorButton":"ColorSheetBody_colorButton__ATN_M","selected":"ColorSheetBody_selected__NRIoZ"};